'use strict';

var util = require('./util');

/**
 * @function
 * @description Creates an event listener on param element
 * @param element
 * @param event
 */

exports.listen = function (element, event) {
    //exclude InternetExplorer due to unsupported ES6 features
    if (util.isInternetExplorer()) {
        return false;
    }

    //creates promise with listener, resolves on the event
    return new Promise(function (resolve, reject) {
        element.addEventListener(event, function () {
            resolve();
        });
    });
};
